// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse {
    static getAttributeTypeMap() {
        return SiteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse.attributeTypeMap;
    }
}
SiteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse.discriminator = undefined;
SiteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse.additionalProperties = false;
SiteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnterpriseCoordinatorSiteAccountUpsearchResponseModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=siteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse.js.map